import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-xl font-heading font-bold text-background-50 mb-4">51影院</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              51影院提供久久影院、悠久影院等全类型影视资源，电视剧大全、电影大全、综艺节目一应俱全，无需注册免费在线观看。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-200 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-200 mb-4">友情链接</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-400">久久影院</span></li>
              <li><span className="text-sm text-background-400">悠久影院</span></li>
              <li><span className="text-sm text-background-400">九九影院</span></li>
              <li><span className="text-sm text-background-400">55影院</span></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-200 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i> service@51cinema.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-wechat-line"></i> cinema51_official
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-time-line"></i> 9:00 - 22:00
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">© 2025 51影院. All rights reserved. 51影院、久久影院、悠久影院、九九影院、55影院 - 免费在线影视平台</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            <Link to="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}